export default __webpack_public_path__ + "static/media/crypto Dark.f13627b3.svg";